import { render, staticRenderFns } from "./proForm.vue?vue&type=template&id=3f4528fa&scoped=true"
import script from "./proForm.vue?vue&type=script&lang=js"
export * from "./proForm.vue?vue&type=script&lang=js"
import style0 from "./proForm.vue?vue&type=style&index=0&id=3f4528fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4528fa",
  null
  
)

export default component.exports